  import {
    FETCH_CLIENTS,
    RESET_CLIENTS,
    FETCH_ALL_CLIENTS,
    FETCH_ALL_CLIENT_OPTIONS,
    CLIENT_QUERY,
    SET_CURRENT_CLIENT_CONTACTS,
    ADD_CLIENT_CONTACT,
    DELETE_CLIENT_CONTACT,
    UPDATE_CLIENT_CONTACT,
    SET_CURRENT_CLIENT_ADDRESSES,
    ADD_CLIENT_ADDRESS,
    DELETE_CLIENT_ADDRESS,
    UPDATE_CLIENT_ADDRESS,
  } from './../../mutation-types';
  import Vue from 'vue';

  export default {
    [FETCH_CLIENTS](state, { clients, pagination }) {
      state.items = clients;
      state.pagination = pagination;
    },

    [RESET_CLIENTS](state) {
      state.all = [];
      state.items = [];
      state.pagination = {};
    },

    [FETCH_ALL_CLIENTS](state, clients) {
      state.all = clients;
    },

    [FETCH_ALL_CLIENT_OPTIONS](state, clients) {
      state.options = clients;
    },

    [CLIENT_QUERY](state, { page, limit, search }) {
      state.query.page = page;
      state.query.limit = limit;
      state.query.search = search;
      state.query.isSet = true;
    },

    [SET_CURRENT_CLIENT_CONTACTS](state, contacts) {
      state.clientContacts = contacts;
    },

    [ADD_CLIENT_CONTACT](state, contact) {
      state.clientContacts.push(contact);
    },

    [DELETE_CLIENT_CONTACT](state, i) {
      state.clientContacts.splice(i, 1);
    },

    [UPDATE_CLIENT_CONTACT](state, { data, i }) {
      state.clientContacts.splice(i, 1, data);
    },

    [SET_CURRENT_CLIENT_ADDRESSES](state, addresses) {
      state.clientAddresses = addresses;
    },

    [ADD_CLIENT_ADDRESS](state, address) {
      state.clientAddresses.push(address);
    },

    [DELETE_CLIENT_ADDRESS](state, i) {
      state.clientAddresses.splice(i, 1);
    },

    [UPDATE_CLIENT_ADDRESS](state, { data, i }) {
      Vue.set(state.clientAddresses, i, data);
      // state.clientAddresses.splice(i, 1, data);
    },
  };



// WEBPACK FOOTER //
// ./src/app/store/modules/client/mutations.js